import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { MainLayout } from '@/components/main-layout'

export const Route = createFileRoute('/_protected')({
  beforeLoad: ({ context, location }) => {
    // Wait for auth to finish loading before checking
    if (context.auth.isLoading) {
      return
    }

    // Redirect to login if not authenticated (same for real and mock backend)
    if (!context.auth.user) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: ProtectedLayout,
})

function ProtectedLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}
